<template>
  <div class="engineer-box">
    <div class="center-container">
      <div class="center-content">
        <div class="table-top">
          <el-button class="new-btn" @click="newUser">
            <i class="el-icon-plus"></i>
            创建
          </el-button>
          <el-input
            class="search-input"
            placeholder="请输入搜索内容"
            v-model="search_name"
            prefix-icon="el-icon-search" @keyup.enter.native="searchName">
          </el-input>
        </div>
        <el-table
          :data="tableData"
          class="table-container"
          :header-cell-style="getRowClass"
          v-loading="loading"
          border>
          <template slot="empty">
            <img class="empty" src="~assets/icon_none.png" alt="">
            <span class="empty-txt">{{empty}}</span>
          </template>
          <el-table-column
            prop="name"
            label="姓名">
          </el-table-column>
          <el-table-column
            prop="user_name"
            label="用户名">
          </el-table-column>
          <el-table-column
            prop="city_name"
            width = "100"
            label="区域">
          </el-table-column>
          <el-table-column label="操作" class="btn-container">
            <template slot-scope="scope" class="btn-container">
              <el-button
                class="edit-btn"
                @click="handleEdit(scope.row)">
                <i class="el-icon-edit-outline"></i>
                修改
                </el-button>
              <el-button
                class="delete-btn"
                @click="handleDelete(scope.$index, scope.row)">
                <i class="el-icon-delete"></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-container">
          <el-pagination
            background
            layout = "total, prev, pager, next"
            v-if="total>0"
            :page-size="limit"
            :total = "total"
            :current-page = "page"
            @current-change = "currentPageFun"
            >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 修改弹窗框 start -->
    <el-dialog
      title="修改个人信息"
      class="dialog-container"
      :visible.sync="dialogUpdate">
      <el-form class="form-container" :model="ruleAdd"  :rules="rules" ref="ruleAdd">
          <el-radio-group class="radio-content" @change="radioChange" v-model="ruleAdd.type">
            <el-radio class="radio-list" :label="1">市场人员</el-radio>
            <el-radio class="radio-list" :label="2">工程师</el-radio>
            <el-radio class="radio-list" :label="5">收发人员</el-radio>
            <el-radio class="radio-list" :label="16">财务人员</el-radio>
          </el-radio-group>
          <el-form-item class="input-list" label="姓名" prop="name">
            <el-input type="text" placeholder="请输入姓名" v-model="ruleAdd.name"></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="用户名" prop="account">
            <el-input type="text" placeholder="请输入用户名" v-model="ruleAdd.account"></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="区域" prop="city_id">
          <el-select v-model="ruleAdd.city_id" placeholder="请选择区域">
            <el-option
              v-for="item in citys"
              :key="item.city_id"
              :label="item.city_name"
              :value="item.city_id">
            </el-option>
          </el-select>
        </el-form-item>
          <el-form-item class="input-list" label="密码" prop="password">
            <el-input type="password" placeholder="请输入密码" v-model="ruleAdd.password"></el-input>
          </el-form-item>
          <el-form-item class="input-list" label="确认密码" prop="password2">
            <el-input type="password" placeholder="请输入密码" v-model="ruleAdd.password2"></el-input>
          </el-form-item>
          <el-checkbox-group v-if="ruleAdd.type === 2" @change="checkChange" class="check-content" v-model="ruleAdd.checkList">
            <el-checkbox class="check-list" label="核验"></el-checkbox>
            <el-checkbox class="check-list" label="批准"></el-checkbox>
          </el-checkbox-group>
          <el-form-item class="btn-list">
            <el-button class="login-btn" @click="submitForm('ruleAdd')">保存</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
    <!-- 修改弹窗框 end -->
    <delete-box @delete="deleteData" v-if="deleteShow"></delete-box>
  </div>
</template>

<script type='text/ecmascript-6'>
import DeleteBox from 'components/DeleteBox.vue'
import { accountRule, name, cityidRule} from 'common/js/loginValidate'
export default {
  data () {
    var passwordContent = (rule, value, callback) => {
      let regFormat = /^[A-Za-z0-9]{6,16}/
      if (value && !(regFormat.test(value))) {
        return callback(this.$message({
          type: 'error',
          message:'密码为6-16位数字或者字母',
          customClass: 'msg-position',
          showClose: true
        }))
      } else {
        return callback()
      }
    }
    var passwordConfirm = (rule, value, callback) => {
      if ( value !== this.ruleAdd.password) {
        callback(this.$message({
          type: 'error',
          message: '两次密码输入不一致',
          customClass: 'msg-position',
          showClose: true
        }))
      } else  {
        callback()
      }
    }
    return {
      empty: '没有收发人员',
      page: 1,
      limit: 10,
      tableData: [],
      total: 0,
      search_name: '',
      dialogUpdate: false,
      ruleAdd: {}, // 修改个人信息
      rules: {
        account: [
          { validator: accountRule, trigger: ['blur'] }
        ],
        password: [
          { validator: passwordContent, trigger: 'blur' }
        ],
        name: [
          { validator: name, trigger: 'blur'}
        ],
        password2: [
          { validator: passwordConfirm, trigger: 'blur'}
        ],
        city_id: [
          { validator: cityidRule, trigger: 'blur'}
        ]
      },
      deleteIndex: 0,
      deleteRow: {},
      deleteShow: false,
      search_show: false,
      citys: []
    }
  },
  beforeCreate () { // 在创建实例之前 先 加载 加载框
    this.loading = true
  },
  created () {
    this.initData()
  },
  methods: {
    getRowClass({ rowIndex }) { // 设置表格第一行的颜色
      if (rowIndex == 0) {
        return 'background:#ECF0F8'
      } else {
        return ''
      }
    },
    initData () { // 初始化数据
      let that = this
      // 获得市场人员的列表
      that.$api.getSalesman({
        type: 5,
        page_num: (that.page - 1) * this.limit
      }).then(res => {
        that.loading = false
        if (res.data.detail.length > 0) {
          that.tableData = res.data.detail
          that.total = Number(res.data.total)
        } else {
          that.tableData = res.data.detail
          that.total = 0
        }
      }).catch(err => {
        that.$message({
          type: 'error',
          message: err,
          customClass: 'msg-position',
          showClose: true
        })
      })
    },
    newUser () { // 添加市场人员
      this.$router.push({
        path: '/addAccount',
        query: {
          type: 5
        }
      })
    },
    handleEdit (row) { // 点击编辑
      let that = this
      this.dialogUpdate = true
      this.getLabCities()
      let checkList = []
      if (row.permission == 1) {
        checkList.push('批准')
      }
      if (row.verification == 1) {
        checkList.push('核验')
      }
      that.ruleAdd = {
        type: 5,
        name: row.name,
        account: row.user_name,
        password: '',
        password2: '',
        user_id: row.user_id,
        checkList: checkList,
        city_id: row.city_id
      }
    },
    radioChange(type) { // 选择 单选框 添加人员的类型
      this.ruleAdd.type = type
    },
    checkChange (e) { // 选择 核验和批准 添加 人员 能够批准 还是能够核准
      this.ruleAdd.checkList = e
    },
    submitForm(formName) { // 修改后 点击保存
      let that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.$api.updateSalesman({
            type: this.ruleAdd.type,
            name: this.ruleAdd.name,
            user: this.ruleAdd.account,
            password: this.ruleAdd.password,
            measure_type: this.ruleAdd.checkList,
            user_id: this.ruleAdd.user_id,
            city_id: this.ruleAdd.city_id
          }).then(res => {
            that.dialogUpdate = false
            if (res.data.msg === true) {
              that.$message({
                type: 'success',
                message: '用户保存成功！！',
                customClass: 'msg-position',
                showClose: true
              })
              /* let index = that.tableData.findIndex(item => {
                return item.user_id === that.ruleAdd.user_id
              })
              let new_data = {
                name: that.ruleAdd.name,
                user_name: that.ruleAdd.account,
                user_id: that.ruleAdd.user_id,
                verification: 0,
                permission: 0
              }
              console.log(new_data)
              that.ruleAdd.checkList.forEach(item => { // 遍历checkList 判断 核验 或者 批准
                if (item == "核验") {
                  new_data.verification = 1
                }
                if (item == "批准") {
                  new_data.permission = 1
                }
              })
              if (Number(that.ruleAdd.type) ===1 || Number(that.ruleAdd.type)==5) { // 如果没有 改变type 就是要改变 tableData的数据
                that.tableData.splice(index, 1, {...new_data})
              }
              if (Number(that.ruleAdd.type) ===2) { // 如果 type 改变了 就要移除该数据
                that.tableData.splice(index, 1)
              } */
              if (that.search_show) {
                that.searchName()
              } else {
                that.initData()
              }
            } else {
              that.$message({
                type: 'error',
                message: res.data.error,
                customClass: 'msg-position',
                showClose: true
              })
            }
          }).catch(err => {
            that.$message({
              type: 'error',
              message: err,
              customClass: 'msg-position',
              showClose: true
            })
          })
        }
      })
    },
    currentPageFun (page) {  // 点击 页码
      this.page = page
      if (this.search_show) {
        this.searchName()
      } else {
        this.initData()
      }
    },
    handleDelete (index,row) { // 点击删除按钮
      let that = this
      that.deleteIndex = index
      that.deleteRow = row
      that.deleteShow = true
    },
    deleteData (val) { // 点击删除的弹出框
      let that = this
      if (val === 'cancle') {
        that.deleteIndex = 0
        that.deleteRow = {}
        that.deleteShow = false
      }
      if (val === 'sure') {
        that.delete(that.deleteIndex, that.deleteRow.user_id)
        that.deleteIndex = 0
        that.deleteRow = {}
        that.deleteShow = false
      }
    },
    delete (index, user_id) { // 点击确认删除
      let that = this
      that.$api.deleteSalesman({
        user_id: user_id
      }).then(res => {
        if (res.data.msg === true) {
          /* that.tableData.splice(index, 1)
          that.total = that.total - 1 */
          that.initData()
          that.$message({
            type: 'success',
            message: '删除成功!',
            customClass: 'msg-position',
            showClose: true
          })
        } else {
          that.$message({
            type: 'error',
            message: '删除失败',
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    },
    searchName () { // 输入名字删除
      let that = this
      if (!this.search_show) {
        this.search_show = true
        this.page = 1
      }
      if (that.search_name) {
        that.$api.searchUser({
          type: 5,
          name: that.search_name,
          page_num: (that.page - 1) * this.limit
        }).then(res => {
          if (res.data.detail.length > 0) {
            that.tableData = res.data.detail
            that.total = Number(res.data.total)
          } else {
            that.tableData = []
            that.total = 0
          }
        }).catch(err => {
          that.$message({
            message: err,
            type: 'error',
            customClass: 'msg-position',
            showClose: true
          })
        });
      } else {
        that.$message({
          type: 'error',
          message: '搜索不能为空！！',
          customClass: 'msg-position',
          showClose: true
        })
      }
    },
    getLabCities() { // 获取所有的区域
      let that = this
      that.$api.getLabCities({
      }).then(res => {
        if (res.data.length > 0) {
          that.citys = [...res.data]
        } else {
          that.$message({
            message: '区域获取错误！',
            type: 'error',
            customClass: 'msg-position',
            showClose: true
          })
        }
      })
    }
  },
  components: {
    DeleteBox
  }
}
</script>

<style lang='stylus' rel='stylesheet/stylus'>
@import '~common/stylus/box.styl'
</style>
